export default [
    { value: 'depannage', label: 'Dépannage' },
    { value: 'entretien', label: 'Entretien' },
    { value: 'installation', label: 'Installation' },
    { value: 'mise_en_service', label: 'Mise en service' },
    { value: 'premiere_visite', label: 'Première visite' },
    { value: 'diagnostic', label: 'Diagnostic' },
]